import { FC } from "react";
import { Box, Flex, Image, Text, useMediaQuery } from "@chakra-ui/react";
import PaymentIcon from "../../../assets/payment.svg";
import { formatNumberMax } from "../../../utils/format.number";
import Button from "../../../components/Button2";
import Icon from "../../../components/Icon";

type BalanceCmpProps = {
  credits?: number;
};
export const BalanceCmp: FC<BalanceCmpProps> = ({ credits }) => {
  return (
    <Flex
      border={"1px solid #FFFFFF"}
      bgColor={"#E13D3D"}
      px={"5px"}
      borderRadius={"40px"}
      justifyContent={"center"}
      alignItems={"center"}
      pos={{ base: "absolute", md: "relative" }}
      top={0}
      right={0}
    >
      <Text
        fontFamily={"font4"}
        fontSize={"11px"}
        fontWeight={700}
        color={"#FFFFFF"}
      >
        {credits === undefined ? "—" : formatNumberMax(credits)}
      </Text>
    </Flex>
  );
};

type InAppCreditsButtonProps = {
  credits?: number;
  onClick: () => void;
};

const InAppCreditsButton: FC<InAppCreditsButtonProps> = ({ credits, onClick }) => {
  const [isSmallerThan900] = useMediaQuery("(max-width: 900px)");
  const label = credits === undefined
    ? "Buy messaging credits"
    : `Buy messaging credits, ${credits.toLocaleString("en-US")} available`;

  return (
    <Flex justify={"center"} align={"center"} fontFamily={"font4"} h={{ base: "40px", md: "46px"}}>
      {
        !isSmallerThan900 ?
          <Flex
            as="button"
            type="button"
            aria-label={label}
            className="focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-700"
            gap={1}
            px={"12px"}
            bgColor={"#F4FFF2"}
            alignItems={"center"}
            cursor={"pointer"}
            justifyContent={"center"}
            border={"1px solid #DFE6ED"}
            borderRadius={"25px"}
            h={{base: "32px", md: "38px"}}
            // boxShadow={"-1px 2px 19px 1px hsla(0, 0%, 50%, .192)"}
            onClick={onClick}
          >
            <Box
              w={(credits ?? 0).toString().length >= 3 ? "38px" : "32px"}
              pos={"relative"}
            >
              <Box position={"absolute"} left={2}>
                <BalanceCmp credits={credits} />
              </Box>
              <Image alt="" src={PaymentIcon} w={"18px"} h={"36px"} />
            </Box>
            <Text
              fontSize={"14px"}
              color={"#4C9063"}
              textTransform={"uppercase"}
              letterSpacing={"1.1px"}
            >
              Mails
            </Text>
          </Flex>
          :
          <Button type="button" aria-label={label} variant="secondary"
            fontFamily={"font4"}
            iconLeft={<Icon name="coin" variant="stroke" />}
            sx={{
              "--button-icon-size": "20px",
              "justifyContent": "flex-start"
            }}
            onClick={onClick}>
            MAILS  <BalanceCmp credits={credits} />
          </Button>
      }
    </Flex>
  );
};

export default InAppCreditsButton;

